import React, { Component } from 'react';
import TouchLink from '../../components/TouchLink';
import { Router, IndexRoute, Route } from 'react-router';

const PageHeader = React.createClass({
    render() {
        return(
            <header className="page-header-wrap">
                <div className="container">
                    <div className="row">
                        <div className="col-xs-12">
                            <div className="page-header">
                                <TouchLink to="/">
                                    <div className="albert-logo"></div>
                                </TouchLink>
                                <div className="whitespace"></div>
                                <nav className="page-nav">
                                    {this.props.children}
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        );
    }
});

export default PageHeader;


/** WEBPACK FOOTER **
 ** ./src/components/PageHeader/PageHeader.js
 **/